import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Separator } from "@chakra-ui/react";
import { AnchorLink } from "@/components/LinkComponents/AnchorLink";
/**
 * This is rendered when current page size is not mobile
 */
export function HeaderLinks() {
    var variant = "header";
    return (_jsxs(_Fragment, { children: [_jsx(AnchorLink, { anchor: "About", variant: variant }), _jsx(AnchorLink, { anchor: "Back", variant: variant }), _jsx(Separator, { variant: "header", "aria-hidden": "true", height: "4", orientation: "vertical" }, "divider"), _jsx(AnchorLink, { anchor: "CreateProfile", variant: variant }), _jsx(AnchorLink, { anchor: "PostJob", variant: variant })] }));
}
